import React, { useEffect, useState } from "react";
import { useTelegram } from "../../hooks/useTelegram";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { CartIcon } from "../../components/GetIcons";
import { useItemContext } from "../../contexts/ItemContext";
import { useAuth } from "../../contexts/AuthProvider";
import {
	getGameLink,
	setGameLink,
	sendSupercell,
	addUserPurchase,
	AddOrder,
	createInvoiceTBank,
	updateUserEmail,
} from "../../router/apiServiceFetch";
import Back from "../../assets/back.svg";
import Exp from "../../assets/exclamation-mark.png";
import Heart from "../../assets/heart.png";
import Square from "../../assets/square.png";
import AlertIcon from "../../assets/alert.svg";
import Exit from "../../assets/exit.svg";
import "./Cart.scss";

const Cart = () => {
	const navigate = useNavigate();
	const [isPseudoFullscreen, setIsPseudoFullscreen] = useState(false); // Псевдо-полноэкранный режим
	const [isConfirming, setIsConfirming] = useState(false);
	const { tg, user, triggerHapticFeedback } = useTelegram();
	const [skipConfirmation, setSkipConfirmation] = useState(false); // Checkbox state
	const { userBase, setUserBase } = useAuth();
	const [error, setError] = useState(false);
	const CODE_ERROR_REASONS = [
		"Не верно вписан Код из почты",
		"Допущена ошибка при вводе e-mail",
	];

	const CODE_NOT_COMING = [
		"На “RU” почту, Код может не прийти, ее можно изменить в настройках игры",
		"Превышен лимит — доступно всего до 3 запросов Кода в сутки (24 часа)",
	];
	const [errorText, setErrorText] = useState("");
	const [superCellReq, setSuperCellReq] = useState(false);
	const [attempts, setAttempts] = useState(0);
	const [gameLinkType, setGameLinkType] = useState(null); // Single game link for the cart
	const [gameLink, setGameLinkState] = useState(null); // Single game link for the cart
	const [editedGameLink, setEditedGameLink] = useState(""); // Editable game link
	const [userEmail, setUserEmail] = useState(""); // Editable game link
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);
	const [confirmationCode, setConfirmationCode] = useState([
		"",
		"",
		"",
		"",
		"",
		"",
	]);
	const [savedLinks, setSavedLinks] = useState({});

	const [showPopup, setShowPopup] = useState(false); // Popup visibility state
	const [showEmailPopup, setShowEmailPopup] = useState(false); // Popup visibility state
	const { handleAddToCart, handleRemoveFromCart, cartItems, handleClearCart } =
		useItemContext();
	const filePath = process.env.REACT_APP_FILE_PATH;
	const togglePseudoFullscreen = () => {
		setIsPseudoFullscreen(!isPseudoFullscreen);
		triggerHapticFeedback("impact", "medium");
	};

	const fetchUserGameLink = async () => {
		if (cartItems.length > 0) {
			try {
				const response = await getGameLink(userBase.userId);
				const matchingLink = response.find(
					(link) => link.gameId === cartItems[0].gameId,
				);
				if (matchingLink) {
					setGameLinkType(matchingLink.gameType);
					setGameLinkState(matchingLink.gameLink);
					setEditedGameLink(matchingLink.gameLink);
				}
			} catch (error) {
				console.error("Error fetching game link:", error);
			}
		}
	};

	useEffect(() => {
		setUserEmail((userBase?.email ?? "").trim());
	}, [userBase?.email]);

	useEffect(() => {
		fetchUserGameLink();
		if (cartItems.find((item) => item.haveSuperCell)) {
			setSuperCellReq(true);
		}
	}, []);

	const handleSaveGameLink = async () => {
		triggerHapticFeedback("impact", "medium");
		if (editedGameLink !== gameLink) {
			try {
				await setGameLink(userBase.userId, cartItems[0].gameId, editedGameLink); // Save the updated link
				setGameLinkState(editedGameLink); // Update the displayed link
				setShowPopup(false); // Close the popup after saving
				setShowConfirmPopup(true);
			} catch (error) {
				console.error("Error saving game link:", error);
			}
		}
		sendSupercell(gameLinkType, editedGameLink);
		setAttempts(1);
		setShowConfirmPopup(true);
		setShowPopup(false);
	};

	const handleSaveEmail = async () => {
		triggerHapticFeedback("impact", "medium");

		const email = (userEmail ?? "").trim();
		if (!email) return;

		try {
			await updateUserEmail(userBase.userId, email);

			// если setUserBase реально есть в useAuth()
			setUserBase((prev) => ({ ...prev, email }));

			setShowEmailPopup(false);

			handleConfirm(); // только при успехе
		} catch (error) {
			console.error("Error saving email:", error);
		}
	};

	const formatCurrency = (number) => {
		return (
			new Intl.NumberFormat("ru-RU", {
				currency: "RUB",
				minimumFractionDigits: 2,
			}).format(number) + " руб"
		);
	};
	const formatCurrencyDisc = (number) => {
		return new Intl.NumberFormat("ru-RU", {
			currency: "RUB",
		}).format(number);
	};

	const handleGoBack = () => {
		triggerHapticFeedback("impact", "medium");
		navigate(-1);
	};

	const handleGoNext = () => {
		triggerHapticFeedback("impact", "medium");

		// Если нужен Supercell — показываем попап для Supercell ID
		if (superCellReq) {
			setShowPopup(true);
			return;
		}

		// Если Supercell НЕ нужен — просим email только если его нигде нет
		const emailFromProfile = (userBase?.email ?? "").trim();
		const emailToUse = (userEmail ?? "").trim() || emailFromProfile;

		if (!emailToUse) {
			setShowEmailPopup(true);
			return;
		}

		// если в стейте было пусто, но в профиле есть — синхронизируем
		if (!userEmail?.trim() && emailFromProfile) setUserEmail(emailFromProfile);

		handleConfirm();
	};
	// const handleGoNext = () => {
	// 	if (!superCellReq) {
	// 		if ((cartItems = [])) {
	// 			setShowEmailPopup(true);
	// 		} else {
	// 			handleConfirm();
	// 		}
	// 	} else {
	// 		triggerHapticFeedback("impact", "medium");
	// 		setShowPopup(true); // Show the popup when "Продолжить" is clicked
	// 	}
	// };
	const handleConfirm = async () => {
		setError(false);
		if (isConfirming) return; // Prevent multiple executions
		setIsConfirming(true);
		triggerHapticFeedback("impact", "medium");

		try {
			const topUpAmount = cartItems.reduce(
				(total, item) => total + item.summedPriceAfterDiscount,
				0,
			);
			const topUpAmountInKopecks = Math.round(topUpAmount * 100);

			const data = {
				order: {
					orderId: 0,
					userId: userBase.userId,
					amount: topUpAmount,
					superCell: superCellReq ? editedGameLink : "",
					code: superCellReq
						? skipConfirmation
							? ""
							: confirmationCode.join("")
						: "",
					state: 0,
				},
				purchases: cartItems.map((item) => ({
					itemId: item.itemId,
					count: item.quantity,
					price: item.summedPriceAfterDiscount,
					friendLink: savedLinks[item.itemId],
				})),
			};
			const resp = await AddOrder(data);
			if (!resp?.ok) {
				setConfirmationCode(["", "", "", "", "", ""]);
				setError(true);
				setErrorText("❌ Не получилось подтвердить Код. ");
				setAttempts((p) => p + 1);
				return;
			} else {
				const orderId = resp.orderId;

				const payData = {
					amount: topUpAmountInKopecks,
					orderId: orderId.toString(),
					description: `userId:${userBase.userId}, userName:${userBase.userName}`,
					type: 0,
				};

				const response = await createInvoiceTBank(payData);

				if (response && response.paymentURL) {
					// Redirect to the payment URL
					setConfirmationCode(["", "", "", "", "", ""]);
					setSavedLinks({});
					handleClearCart();
					setShowConfirmPopup(false);
					tg.openLink(response.paymentURL);
				} else if (response.status == "CONFIRMED") {
					setShowConfirmPopup(false);
					setConfirmationCode(["", "", "", "", "", ""]);
					setSavedLinks({});
					navigate("/profile");
				} else {
					console.error("Failed to retrieve payment URL.");
				}
			}
		} catch (error) {
			console.error("Error in handleConfirm:", error);
		} finally {
			setTimeout(() => {
				setIsConfirming(false); // Reset state
			}, 300);
		}
	};

	const handleResendCode = () => {
		triggerHapticFeedback("impact", "medium");
		setConfirmationCode(["", "", "", "", "", ""]);
		setAttempts((prevAttempts) => prevAttempts + 1); // Properly increment attempts
		sendSupercell(gameLinkType, editedGameLink);
		setError(false);
	};
	return (
		<div
			className="cart"
			style={{
				zIndex: showPopup || showEmailPopup || isPseudoFullscreen ? 1001 : 100,
			}}
		>
			{isPseudoFullscreen && (
				<div className="pseudo-fullscreen">
					<video
						src={`${filePath}/video.mp4`}
						autoPlay
						loop
						muted={false}
						playsInline
						controls={false}
						className="pseudo-fullscreen-video"
					/>
					<button
						onClick={togglePseudoFullscreen}
						className="exit-fullscreen-button"
					>
						ЗАКРЫТЬ
					</button>
				</div>
			)}
			{cartItems.length === 0 && (
				<div className="no-items">
					<CartIcon fillColor="#FFFFFF40" className="no-items-svg" />
				</div>
			)}
			{(showPopup || showEmailPopup || showConfirmPopup) && (
				<div className="overlay"></div>
			)}
			{/* Overlay to darken background */}
			<div className="back-nav">
				<div className="sum">
					<div className="back-btn" onClick={handleGoBack}>
						<button>
							<img src={Back} alt="back" />
						</button>
					</div>
					<h2>Корзина</h2>
				</div>
				<div className="sumAmnt">
					<h3>
						к оплате{" "}
						{formatCurrency(
							cartItems.reduce(
								(total, item) => total + item.summedPriceAfterDiscount,
								0,
							),
						)}
					</h3>
				</div>
			</div>
			<motion.div
				initial={{ height: 0, opacity: 0 }}
				animate={{
					height: cartItems.length > 0 ? "100%" : 0,
					opacity: cartItems.length > 0 ? 1 : 0,
				}}
				transition={{ duration: 0.3 }}
				className={`cart-container ${
					showPopup || showEmailPopup || showConfirmPopup ? "blur" : ""
				}`}
			>
				<div className="cart-content">
					{cartItems.length > 0 ? (
						<>
							<div className="alert">
								<img src={AlertIcon} alt="item" />
								<p>Перед покупкой проверьте наличие товара у вас на аккаунте</p>
							</div>
							{cartItems.map((item) => (
								<div className="item-content" key={item.itemId}>
									<div className="item">
										<div
											className={`item-info-content ${
												item.noLogin ? "item-info-content-dashed" : ""
											}`}
										>
											<div className="item-pic">
												<img
													src={`${filePath}/Games/${item.fileName}`}
													alt={item.name}
													className="pic"
												/>
											</div>
											<div className="item-info">
												<h3>
													<img
														src={`${filePath}/Games/${item.parentFileName}`}
													/>
													{item.name}
												</h3>
												<div className="realPrice">
													{item.summedPrice !=
														item.summedPriceAfterDiscount && (
														<p>{formatCurrencyDisc(item.summedPrice)}</p>
													)}
													<span>
														{formatCurrency(item.summedPriceAfterDiscount)}
													</span>
												</div>

												<div className="gameSliderBtnDiv">
													<div className="gameSliderButtons">
														<button onClick={() => handleRemoveFromCart(item)}>
															-
														</button>
													</div>
													<p className="quantity">{item.quantity}</p>
													<div className="gameSliderButtons">
														<button onClick={() => handleAddToCart(item)}>
															+
														</button>
													</div>
												</div>
											</div>
										</div>
										{item.noLogin && (
											<div className="item-link">
												<div className="border-div">
													<div className="border-div"></div>
												</div>
												<input
													autoComplete="on"
													type="text"
													placeholder="Ссылка для запроса дружбы"
													value={savedLinks[item.itemId] || ""} // Use default empty string
													onChange={(e) => {
														setSavedLinks((prevLinks) => ({
															...prevLinks,
															[item.itemId]: e.target.value, // Update specific itemId in the state
														}));
													}}
													className="edit-item"
												/>
											</div>
										)}
									</div>
								</div>
							))}
						</>
					) : (
						<p className="empty-cart">Ваша корзина пуста.</p>
					)}
					{cartItems.length > 0 &&
						!showPopup &&
						!showEmailPopup &&
						!showConfirmPopup && (
							<div className="cart-footer">
								<div className="cart-div clear-cart">
									<button className="clear-cart-btn" onClick={handleClearCart}>
										Очистить корзину
									</button>
								</div>
								<div className="cart-div">
									<button className="buy-cart-btn" onClick={handleGoNext}>
										{superCellReq ? "Продолжить" : "Купить"}
									</button>
								</div>
							</div>
						)}
				</div>
			</motion.div>
			{showPopup && (
				<motion.div
					initial={{ y: "100%", opacity: 0 }}
					animate={{ y: 0, opacity: 1 }}
					exit={{ y: "100%", opacity: 0 }}
					transition={{ duration: 0.3 }}
					className="footer-popup"
				>
					<img
						src={Exit}
						className="exit"
						onClick={() => {
							setShowPopup(false);
							triggerHapticFeedback("impact", "medium");
						}}
					/>
					<div className="game-link">
						<input
							type="text"
							value={editedGameLink}
							autoComplete="on"
							placeholder="Почта игры (SUPERCELL id)"
							onChange={(e) => setEditedGameLink(e.target.value)}
							className="game-link-input"
						/>
					</div>
					<div className="popup-text">
						<p>
							<img src={Square} className="text-icon" /> Введите почту вашего
							аккаунта и нажмите кнопку «Купить»
						</p>
						<p>
							<img src={Exp} className="text-icon" /> Время обработки вашей
							заявки может затянутся в пиковые часы, вам дадут знать как все
							будет Готово!
						</p>
						<p>
							<img src={Exp} className="text-icon" /> До и После покупки,
							желательно час не заходить на игровой аккаунт, для исключения
							шанса блокировки.
						</p>
						<p>
							<img src={Heart} className="text-icon" /> Спасибо за понимание{" "}
							<img src={Heart} className="text-icon" />
						</p>
					</div>

					<div className="buy-div">
						<button
							onClick={handleSaveGameLink} //
							className="buy-link"
							// disabled={!editedGameLink.trim()} // Disable if input is empty
						>
							Купить
						</button>
					</div>
					{/* <div className="buy-div">
            <button
              onClick={togglePseudoFullscreen}//handleSaveGameLink
              className="buy-link"
            // disabled={!editedGameLink.trim()} // Disable if input is emptyКупить
            >
              Посмотреть Видео
            </button>
          </div>  */}
				</motion.div>
			)}
			{showEmailPopup && !showPopup && (
				<motion.div
					initial={{ y: "100%", opacity: 0 }}
					animate={{ y: 0, opacity: 1 }}
					exit={{ y: "100%", opacity: 0 }}
					transition={{ duration: 0.3 }}
					className="footer-popup"
				>
					<img
						src={Exit}
						className="exit"
						onClick={() => {
							setShowEmailPopup(false);
							setUserEmail((userBase?.email ?? "").trim()); // откат
							triggerHapticFeedback("impact", "medium");
						}}
					/>
					<div className="game-link">
						<input
							type="text"
							value={userEmail}
							autoComplete="on"
							placeholder="Почта"
							onChange={(e) => setUserEmail(e.target.value)}
							className="game-link-input"
						/>
					</div>
					<div className="popup-text">
						<p>
							<img src={Square} className="text-icon" /> Введите почту на
							который будет отправлятся чек покупки и нажмите кнопку «Купить»
						</p>
						<p>
							<img src={Exp} className="text-icon" /> Время обработки вашей
							заявки может затянутся в пиковые часы, вам дадут знать как все
							будет Готово!
						</p>
						<p>
							<img src={Exp} className="text-icon" /> До и После покупки,
							желательно час не заходить на игровой аккаунт, для исключения
							шанса блокировки.
						</p>
						<p>
							<img src={Heart} className="text-icon" /> Спасибо за понимание{" "}
							<img src={Heart} className="text-icon" />
						</p>
					</div>

					<div className="buy-div">
						<button
							onClick={handleSaveEmail} //
							className="buy-link"
							disabled={!userEmail.trim()}
							// disabled={!editedGameLink.trim()} // Disable if input is empty
						>
							Купить
						</button>
					</div>
				</motion.div>
			)}
			{showConfirmPopup && (
				<motion.div
					initial={{ height: 0, opacity: 0 }}
					animate={{
						height: showConfirmPopup ? "auto" : 0,
						opacity: showConfirmPopup ? 1 : 0,
					}}
					transition={{ duration: 0.3 }}
					className="footer-popup-new"
				>
					<img
						src={Exit}
						className="exit"
						onClick={() => {
							setShowConfirmPopup(false);
							triggerHapticFeedback("impact", "medium");
						}}
					/>
					<div className="confirmation-popup">
						<h3>Введите код подтверждения</h3>
						<div className="confirmation-inputs">
							{confirmationCode.map((digit, index) => (
								<input
									key={index}
									type="text"
									autoComplete="off"
									maxLength={1}
									value={digit}
									onChange={(e) => {
										const newCode = [...confirmationCode];
										newCode[index] = e.target.value.replace(/\D/, ""); // Allow only digits
										setConfirmationCode(newCode);

										// Move to the next input automatically
										if (e.target.value && index < confirmationCode.length - 1) {
											document.getElementById(`digit-${index + 1}`).focus();
										}
									}}
									onKeyDown={(e) => {
										// Handle backspace to move to the previous input
										if (
											e.key === "Backspace" &&
											!confirmationCode[index] &&
											index > 0
										) {
											document.getElementById(`digit-${index - 1}`).focus();
										}
									}}
									id={`digit-${index}`}
									className="digit-input"
								/>
							))}
						</div>
						{error && (
							<div className="code-error">
								<p className="code-error-title">
									❌ Не получилось подтвердить Код.
								</p>
								<p className="code-error-subtitle">
									<img src={Exp} className="text-icon" />
									Возможные причины ошибки:
								</p>
								<ul>
									{CODE_ERROR_REASONS.map((t) => (
										<li key={t}>• {t}</li>
									))}
								</ul>

								<p className="code-error-subtitle">
									<img src={Exp} className="text-icon" /> Если не приходит Код
									на почту:
								</p>
								<ul>
									{CODE_NOT_COMING.map((t) => (
										<li key={t}>• {t}</li>
									))}
								</ul>
							</div>
						)}
						<p>
							Введите код, который был отправлен на вашу почту, указанную при
							оформлении заказа, для подтверждения покупки.
						</p>
						{/* 
						<h1>Обязательно запросите код вручную (если покупка со входом)</h1>
						<p>
							Как это сделать, можете посмотреть в видео гайде по кнопке ниже{" "}
						</p>

						<p className="senter">
							<img src={Heart} className="text-icon" /> Спасибо за понимание{" "}
							<img src={Heart} className="text-icon" />
						</p>*/}
						{/* <div className="buy-div">
							<button
								onClick={togglePseudoFullscreen} //handleSaveGameLink
								className="buy-link"
								// disabled={!editedGameLink.trim()} // Disable if input is emptyКупить
							>
								Посмотреть Видео
							</button>
						</div>*/}
						{attempts > 3 && (
							<div className="skip-confirmation">
								<label>
									<input
										type="checkbox"
										checked={skipConfirmation}
										onChange={(e) => setSkipConfirmation(e.target.checked)}
									/>
									Продолжить покупку без кода
								</label>
							</div>
						)}

						<div className="confirmation-actions">
							<button onClick={handleResendCode} className="resend-button">
								Отправить снова
							</button>
							<button
								onClick={handleConfirm}
								className="confirm-button"
								disabled={
									isConfirming ||
									confirmationCode.some(
										(digit) => digit === "" && !skipConfirmation,
									)
								} // Disable if any input is empty
							>
								{isConfirming ? "Подтверждение..." : "Подтвердить"}
							</button>
						</div>
					</div>
				</motion.div>
			)}
		</div>
	);
};

export default Cart;
